import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { FormEntryPage } from '../../../../shared/pages/FormEntryPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryInputRef, SingleInputState } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { OtherProviderFlow, PackageNameFlow } from '../../pageFlowData'
import { data } from './data'

export const OtherProvider: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    issue: { otherProvider },
  } = state

  const [inputData, setInputData] = useState<SingleInputState>({
    renderError: false,
    value: '',
  })
  const OtherProviderInput = useRef<FormEntryInputRef>(null)

  const getValue = () => {
    return cleanText(OtherProviderInput?.current?.formEntryInput?.value || '')
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${OtherProviderFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_OTHER_PROVIDER', data: value })
    dispatch({ type: 'UPDATE_STEP', data: PackageNameFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: PackageNameFlow.PROGRESS_VALUE })
  }

  const handleSubmit = () => {
    const value = getValue()
    const isValid: boolean = isNotEmpty(value)

    setInputData({
      renderError: !isValid,
      value: value,
    })

    if (isValid) {
      handleTracking(value)
      handleDispatch(value)
    }
  }

  const { renderError, value: errorValue } = inputData
  const { imgObj, title } = data

  return (
    <FormEntryPage
      buttonText="Next"
      defaultValue={otherProvider}
      fieldData={{
        renderError: renderError,
        value: errorValue,
      }}
      handleSubmit={handleSubmit}
      id="other-provider"
      imgObj={imgObj}
      isFocused
      optional={false}
      placeholderText=""
      ref={OtherProviderInput}
      testId="other-provider"
      title={title}
    />
  )
}
